import { render, staticRenderFns } from "./LeaveDashboard.vue?vue&type=template&id=fa095604"
import script from "./LeaveDashboard.vue?vue&type=script&lang=js"
export * from "./LeaveDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports